import Vec2 from 'vec2';

import { SHAPE_LABEL_ALTERED_CORNER_ADJUSTER_DENOMINATOR } from '~/core/constants';
import { getDistanceBetween } from '~/core/helpers';
import { DrawingEdge, DrawingShape } from '~/core/models';

export const determineShapeLabelPosition = (
  shape: DrawingShape,
  requiredEdgeLength: number
) => {
  let shapeTextPos: Vec2 | undefined;
  let longestHorizontalTopEdge = {
    nextBestFlatTop: new Vec2(0, 0),
    length: 0,
  };

  // horizontal top edges only
  const horizontalTopEdges = shape.drawingEdges.filter(
    (edge: DrawingEdge) => !Math.round(edge.dirVec.y) && edge.dirVec.x < 0
  );

  // sort edges by highest point per edge
  horizontalTopEdges.sort(
    (a, b) =>
      Math.max(a.startDisplayVec.y, a.endDisplayVec.y) -
      Math.max(b.startDisplayVec.y, b.endDisplayVec.y)
  );

  // this loop attempts set the position of the shape label on the highest horizontal edge that is long enough
  horizontalTopEdges.forEach((edge) => {
    const endCorner = shape.cornerMap[edge.endCornerId];

    // edge lengths appropriate for the shape label may be impacted by corner radii or diagonals (display end) or not (real)
    let realOrDisplayEnd;

    if (endCorner.size) {
      const leftShiftForRadiusCorner = Math.pow(
        endCorner.size,
        1 / SHAPE_LABEL_ALTERED_CORNER_ADJUSTER_DENOMINATOR
      );
      //only apply adjustment if no diagonalLength and corner is visible
      const shapeNotVisibleInCanvas =
        !shape.cornerMap[edge.endCornerId].isVisibleInCanvas;
      const shapeHasDiagonalLength =
        !!shape.cornerMap[edge.endCornerId].diagonalLength;

      realOrDisplayEnd = new Vec2(
        edge.endDisplayVec.x -
          (shapeNotVisibleInCanvas || shapeHasDiagonalLength
            ? 0
            : leftShiftForRadiusCorner),
        edge.endDisplayVec.y
      );
    } else {
      realOrDisplayEnd = shape.cornerMap[edge.endCornerId].coords;
    }
    const edgeDisplayLength = getDistanceBetween(
      edge.startDisplayVec,
      realOrDisplayEnd
    );

    if (edgeDisplayLength > requiredEdgeLength && shapeTextPos === undefined) {
      shapeTextPos = realOrDisplayEnd;
    } else if (edgeDisplayLength > longestHorizontalTopEdge.length) {
      longestHorizontalTopEdge = {
        nextBestFlatTop: realOrDisplayEnd,
        length: edgeDisplayLength,
      };
    }
  });

  return { shapeTextPos, longestHorizontalTopEdge };
};
